import React, { createContext } from 'react';

const OptionsContext = createContext({});

export { OptionsContext };
